<div class="conteudo-tecnico">
  <div class="opcoes">
    <div class="p-3">
      <div class="titulo">
        <span>Encaminhar para o técnico</span>
      </div>

      <div class="mt-5 mb-5">
        <app-botao-voltar></app-botao-voltar>
      </div>

      <div class="sub-titulo my-2">
        Selecione o técnico
      </div>

      <form [formGroup]="encaminhaTecnicoForm" (submit)="doEncaminhar()">
        <div>
          <label>Técnico</label>
          <select formControlName="tecnico">
            <option [ngValue]="null" selected>
              Selecionar
            </option>
            <option *ngFor="let tecnico of tecnicos" [ngValue]="tecnico.codigo">
              {{tecnico.nome}}
            </option>
          </select>
        </div>
        <div class="d-flex justify-content-end">
          <button class="button-primary" [disabled]="!isButtonEnabled()" type="submit">
            {{labelBotao}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>